;; Copyright (C) 2017, Doctor Evidence. All rights reserved.

(ns dre.utils.query
  "A search query data model."
  {:authors ["Miroslav Smatana"]}
  (:require
   [clojure.walk :as walk]
   [dre.shared.interface.search.pills :as pills]
   [dre.shared.interface.search.util :refer [search-query->route]]
   [taoensso.timbre :refer-macros [warn debug]]))


;;;; Specs

;;; Base query

;;;; Implementation details

;;;; Public API

(defn some-pills-query
  "Like predicate, but returns flats pill"
  [search-query]
  (let [{:keys [:query/pills]} search-query
        pill (pills/flats->pill pills)]
    (and (not (pills/empty-completed-pill? pill))
         pill)))

(defn dissoc-pill-metadata
  [pill]
  (let [pf (fn [x] (if (map? x)
                     (dissoc x :pill/semgroup-labels :pill/definitions
                             :pill/label-group :dre.search-form.db/indent)
                     x))]
    (walk/prewalk pf pill)))

(defn pills-api-params
  "Returns an api params map from a given pills search query. Prints
  warning and returns nil if query had empty pills or wasn't a pills
  query."
  [search-query]
  (if-let [pill (some-pills-query search-query)]
    {:query/pill (dissoc-pill-metadata pill)}
    (do
      (warn "Query doesn't contain pills"
            (pr-str search-query))
      nil)))

(defn coerce
  [search-query]
  (let [mf (fn [m]
             (let [[k v] m
                   k (if (string? k) (keyword k) k)
                   v (cond (= :query/type k) (keyword v)
                           (= :query/blueprints k) (pills/coerce v)
                           (= :query/pills k) (pills/coerce v)
                           :else v)]
               [k v]))]
    (into {} (map mf (seq search-query)))))

(defn route
  "Returns a route map from a given search query."
  [search-query roles-hash]
  (search-query->route search-query roles-hash))